import HighlightWord from "../../../../src/components/HighlightWord";
import * as style from "../../../../src/content/blog-posts/getting-started-in-schutzhund-igp/style.module.scss";
import Link from 'gatsby-link';
import * as React from 'react';
export default {
  HighlightWord,
  style,
  Link,
  React
};